import { render, staticRenderFns } from "./AppV3Labels.vue?vue&type=template&id=e1ba8bf0"
import script from "./AppV3Labels.vue?vue&type=script&lang=js"
export * from "./AppV3Labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports